<template>
  <div class="auth">
    <h3 v-if="!sended">Восстановление пароля</h3>
    <h3 v-if="sended">Введите код из смс</h3>
    <div v-if="errors.length">
      <div v-for="(error, key) in errors" :key="key" class="auth__alert">
        {{ error }}
      </div>
    </div>
    <div class="auth__form">
      <div v-if="!sended" class="auth__passwordSubmit">
        Укажите номер телефона и мы отправим Вам временный код
      </div>
      <div v-if="sended" class="auth__passwordSubmit">
        Введите пожалуйста код из смс, что бы перейти к смене пароля
      </div>
      <div class="auth__formDiv">
        <input
          v-model="phone"
          class="input"
          type="text"
          name="phone"
          v-mask="{
            mask: '+7 (F##) ###-##-##',
            tokens: {
              F: {
                pattern: /(?!8)\d/,
              },
              '#': { pattern: /\d/ },
            },
          }"
          placeholder="Мобильный телефон"
        />
        <input
          v-if="sended"
          v-model="code"
          class="input"
          type="text"
          name="code"
          placeholder="Введите код из смс"
        />
      </div>
      <div class="auth__btnBlock">
        <p v-if="sended && exper > 0">До повторной отправки осталось {{ exper }} секунд</p>
        <button :disabled="btn_clicked" v-if="!sended" @click="sendForgotData" class="auth__submit">Получить код</button>
        <a v-if="sended && exper <= 0" href="#" @click.prevent="sendForgotData">Получить код повторно</a>
        <button @click="$router.push({name: 'login'})" class="auth__btn-back">Назад</button>
        <button v-if="sended" @click="checkForgotCode" class="auth__submit">Проверить код</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  name: "ForgotView",
  data() {
    return {
      errors: [],
      phone: null,
      btn_clicked: false,
      send_forgot_time: 0,
      sended: false,
      code: '',
      exper: 0,
      interval: null,
      time_to_send: 90,
    };
  },
  mounted() {
    this.sended = this.is_sended;
    this.exper = this.exp;
    this.counterStart();
  },
  methods: {
    counterStart () {
      this.interval = setInterval(() => {
        if (this.exper <= 0) {
          clearInterval(this.interval)
        } else {
          this.exper--
        }
      }, 1000);
    },
    async sendForgotData() {
      // console.log(this.$myApp.token.get());
      if (this.exper > this.time_to_send) {
        this.errors = [];
        this.errors.push('До повторной отправки осталось ' + this.exper + ' секунд');
        return;
      }
      if (this.validationForgot()) {
        this.btn_clicked = true;
        let date_now = (new Date()).getTime();
        if(date_now < this.send_forgot_time){
          return;
        }
        this.send_forgot_time = date_now + 5000;
        let params = {
          action: "forgot",
          object: "cpa",
          phone: this.phone.replace(/\D/g, "").substring(1),
          token: this.$myApp.token.get()
        };
        let api = await this.$api2.get(params);

        if (api.error) {
          this.errors = [];
          this.errors = api.errors;
          this.phone = null;
        }
        if (api.success) {

          alert(api.data.msg);
          this.sended = true;
          window.localStorage.setItem("mlife_exp",  Date.now().toString());
          window.localStorage.setItem("sended", 'Y');
          this.exper = this.time_to_send;
          this.counterStart();
          // setTimeout(() => (this.$router.push({ name: "login" })), 2000);
        }
      }
    },
    validationForgot() {
      this.errors = [];
      if (!this.phone) {
        this.errors.push("Укажите номер телефона.");
      }
      if (!this.errors.length) {
        return true;
      } else {
        return false;
      }
    },
    async checkForgotCode () {
      if (this.validationForgot()) {
        if (this.code === '') {
          this.errors = [];
          this.errors.push('Введите код из СМС');
          return;
        }
        let params = {
          action: "check-forgot-code",
          object: "cpa",
          phone: this.phone.replace(/\D/g, "").substring(1),
          token: this.$myApp.token.get(),
          code: this.code,
        };
        let api = await this.$api2.get(params);

        if (api.error) {
          this.errors = [];
          this.errors = api.errors;
          this.code = '';
        }
        if (api.success) {
          localStorage.removeItem('sended');
          localStorage.removeItem('mlife_exp');
          this.$router.push({name: 'changepass'})
        }
      }
    },
  },
  directives: { mask },
  computed: {
    is_sended() {
      let s = window.localStorage.getItem("sended");
      return s === "Y";
    },
    exp() {
      let e = window.localStorage.getItem("mlife_exp");
      return this.time_to_send - (Math.floor((Date.now() - e) / 1000));
    }
  },
};
</script>

<style scoped>
.auth .auth__form .auth__formDiv input {
  margin-top: 15px;
}
.auth .auth__form .auth__btnBlock button.auth__submit {
  margin-top: 15px;
}
</style>
